import { ETPListItem } from '../entities/etp.model';

export class ETPs {
  public static get(): ETPListItem[] {
    return [
      {
        name: 'Bitcoin',
        etps: [
          {
            description: 'CoinShares Physical Bitcoin (1:1.000)',
            wkn: 'A3GPMN',
            isin: 'GB00BLD4ZL17',
          },
          {
            description: '21Shares Bitcoin ETP',
            wkn: 'A2T64E',
            isin: 'CH0454664001',
          },
        ],
      },
      {
        name: 'Ethereum',
        etps: [
          {
            description: 'CoinShares Physical Ethereum (1:33,3)',
            wkn: 'A3GQ2N',
            isin: 'GB00BLD4ZM24',
          },
          {
            description: '21Shares Ethereum ETP',
            wkn: 'A2T68Z',
            isin: 'CH0454664027',
          },
        ],
      },
      {
        name: 'Litecoin',
        etps: [
          {
            description: 'CoinShares Physical Litecoin (1:5)',
            wkn: 'A3GRUD',
            isin: 'GB00BLD4ZP54',
          },
        ],
      },
      {
        name: 'XRP',
        etps: [
          {
            description: 'CoinShares Physical XRP (40:1)',
            wkn: 'A3GRUE',
            isin: 'GB00BLD4ZN31',
          },
          {
            description: '21Shares Ripple XRP ETP',
            wkn: 'A2UBKC',
            isin: 'CH0454664043',
          },
        ],
      },
      {
        name: 'Polkadot',
        etps: [
          {
            description: 'CoinShares Physical Polkadot (staked)',
            wkn: 'A3GVC0',
            isin: 'GB00BNRRFW10',
            stakingReward: 0.05,
          },
          {
            description: '21Shares Polkadot ETP',
            wkn: 'A3GPQM',
            isin: 'CH0593331561',
          },
        ],
      },
      {
        name: 'Tezos',
        etps: [
          {
            description: 'CoinShares Physical Tezos (staked)',
            wkn: 'A3GVCZ',
            isin: 'GB00BMWB4803',
            stakingReward: 0.03,
          },
          {
            description: '21Shares Tezos ETP',
            wkn: 'A22J1S',
            isin: 'CH0491507486',
          },
        ],
      },
      {
        name: 'Bitcoin Cash',
        etps: [
          {
            description: 'HANETF Physical Bitcoin Cash',
            wkn: 'A3GTBU',
            isin: 'DE000A3GTBU5',
          },
          {
            description: '21Shares Bitcoin Cash ETP',
            wkn: 'A2126N',
            isin: 'CH0475552201',
          },
        ],
      },
      {
        name: 'Solana',
        etps: [
          {
            description: 'CoinShares Physical Solana (staked)',
            wkn: 'A3GXNS',
            isin: 'GB00BNRRFY34',
            stakingReward: 0.03,
          },
          {
            description: '21Shares Solana SOL ETP',
            wkn: 'A3GSS0',
            isin: 'CH1114873776',
          },
        ],
      },
      {
        name: 'Stellar',
        etps: [
          {
            description: 'HANETF Physical Stellar',
            wkn: 'A3GVK0',
            isin: 'DE000A3GVK06',
          },
          {
            description: '21Shares Stellar ETP',
            wkn: 'A3GRTM',
            isin: 'CH1109575535',
          },
        ],
      },
      {
        name: 'Cardano',
        etps: [
          {
            description: 'CoinShares Physical Cardano (staked)',
            wkn: 'A3GVCX',
            isin: 'GB00BNRRF659',
            stakingReward: 0.03,
          },
          {
            description: '21Shares Cardano ETP',
            wkn: 'A3GRTN',
            isin: 'CH1102728750',
          },
        ],
      },
      {
        name: 'Polygon',
        etps: [
          {
            description: '21Shares Physical Polygon',
            wkn: 'A3GUQJ',
            isin: 'CH1129538448',
          },
        ],
      },

      {
        name: 'FTX Token',
        etps: [
          {
            description: 'CoinShares Physical FTX Token',
            wkn: 'A3GX39',
            isin: 'GB00BNRRFJ82',
          },
        ],
      },
      {
        name: 'Chainlink',
        etps: [
          {
            description: 'CoinShares Physical Chainlink',
            wkn: 'A3GYRF',
            isin: 'GB00BMWB4910',
          },
        ],
      },
      {
        name: 'Uniswap',
        etps: [
          {
            description: 'CoinShares Physical Uniswap',
            wkn: 'A3GYRG',
            isin: 'GB00BNRRG624',
          },
        ],
      },
      {
        name: 'Matic',
        etps: [
          {
            description: 'CoinShares Physical Matic (staked)',
            wkn: 'A3GVCY',
            isin: 'GB00BNRRB013',
            stakingReward: 0.05,
          },
        ],
      },
      {
        name: 'Cosmos',
        etps: [
          {
            description: 'CoinShares Physical Cosmos (staked)',
            wkn: 'A3GY73',
            isin: 'GB00BNRRF980',
            stakingReward: 0.05,
          },
        ],
      },
      {
        name: 'Multi-Asset',
        etps: [
          {
            description: '21Shares Bytetree BOLD',
            wkn: 'A3GYXW',
            isin: 'CH1146882308',
          },
          {
            description: '21Shares Crypto Basket',
            wkn: 'A2TT3D',
            isin: 'CH0445689208',
          },
          {
            description: '21Shares Crypto Basket Equal Weight',
            wkn: 'A3GUMV',
            isin: 'CH1135202161',
          },
          {
            description: '21Shares Crypto Basket 10',
            wkn: 'A3GUMU',
            isin: 'CH1135202179',
          },
          {
            description: '21Shares Bitwise Select 10',
            wkn: 'A2107P',
            isin: 'CH0475986318',
          },
          {
            description: '21Shares Crypto Mid-Cap Index',
            wkn: 'A3GWD4',
            isin: 'CH1130675676',
          },
        ],
      },
    ];
  }
}
